import { FunctionComponent, useContext, useEffect } from 'react';
import styles from './DirectoryCard.module.scss';
import { DirectoryListType } from '../../directory-list/DirectoryList';
import { AppContext } from '../../../context/AppContext';
import { useHistory } from 'react-router-dom';
// import { IDirectoryButtonProps } from '../../directory-button-area/directory-button/DirectoryButton';

export interface IDirectoryCardProps {
  title: string;
  listType: DirectoryListType;
  currentListType: DirectoryListType;
}

const DirectoryCard: FunctionComponent<IDirectoryCardProps> = ({ title, currentListType, listType, children }) => {
  const appContext = useContext(AppContext);
  const history = useHistory();

  useEffect(() => {
    if (currentListType === listType) {
      appContext.updateListType(listType);
    }
  }, [currentListType, listType]);

  return (
    <button
      className={`${styles.directoryCard}${appContext.isDirectorySelected && currentListType === listType ? ' ' + styles.isActive : ''}`}
      onClick={() => {
        appContext.updateListType(listType);
        appContext.updateSelected(true);
        history.push('/');

        // TODO: convert this to custom hook or global function
        appContext.updateSelectedSpecialty('');
        appContext.updateChosenSpecialty('');
        appContext.updateName('');
        appContext.updateLocation('');
        appContext.updateDistance({
          name: 'Select Distance',
          distance: -1
        });
        appContext.updateIsDisabled(false);
      }}
    >
      <div>{children}</div>
      <div className={styles.cardText}>{title}</div>
    </button>
  );
};

export default DirectoryCard;
